import { getModelFrontLogs as getModelFrontLogsApi, getModelFrontLogById as getModelFrontLogByIdApi } from '../../api/analytics3d';
import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../../store';
import { setNotifications } from '../slices/notifications';

export const getModelFrontLogById = createAsyncThunk(
    'modelFrontLogs/getModelFrontLogById',
    async (logId: number, { rejectWithValue }) => {
        try {
            const response = await getModelFrontLogByIdApi(logId);
            return response?.result ?? response;
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message, type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);

export const getModelFrontLogs = createAsyncThunk(
    'modelFrontLogs/getModelFrontLogs',
    async (queryParams: any, { rejectWithValue }) => {
        try {
            return await getModelFrontLogsApi(queryParams);
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message, type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);
